"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HTMLSubmit = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var HTMLSubmit = function HTMLSubmit(_ref) {
  var submitting = _ref.submitting,
      buttonText = _ref.buttonText;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, submitting && /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null), !submitting && /*#__PURE__*/_react.default.createElement("button", {
    type: "submit"
  }, buttonText));
};

exports.HTMLSubmit = HTMLSubmit;
var _default = HTMLSubmit;
exports.default = _default;
HTMLSubmit.propTypes = {
  /** passed down from React Final Form when submitting */
  submitting: _propTypes.default.bool,

  /** button text */
  buttonText: _propTypes.default.string
};
HTMLSubmit.defaultProps = {
  buttonText: 'Submit',
  submitting: false
};